import { render, staticRenderFns } from "./NewsCenterDetails.vue?vue&type=template&id=4adf60d4&"
import script from "./NewsCenterDetails.vue?vue&type=script&lang=js&"
export * from "./NewsCenterDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenterDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports